import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteSubscription, getSubscriptions } from '../../store/actions/subscription/subscription.action';
import Subscriptions from '../../components/Subscription/Subscriptions';
import PageLoader from '../../components/Common/PageLoader';

const SubscriptionsContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const subscriptions = useSelector((state) => state.subscription.list);
  const isFetching = useSelector((state) => state.subscription.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const subscriptionCategory = categories.find((category) => category.link === 'subscriptions');
      if (subscriptionCategory) {
        setMode(subscriptionCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Subscription category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete subscription
  const handleDeleteSubscription = useCallback((subscription) => {
    dispatch(deleteSubscription(subscription));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getSubscriptions());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare subscriptions info object
  const subscriptionsInfo = {
    deleteSubscription: handleDeleteSubscription,
    subscriptions
  };

  return (
    <section className="subscription-list">
      <Subscriptions mode={mode} subscriptionsInfo={subscriptionsInfo} />
    </section>
  );
};

export default SubscriptionsContainer;
